<template>
  <div class="main-container">
    <avue-crud ref="crud"
               :page.sync="page"
               :data="tableData"
               :table-loading="tableLoading"
               :option="tableOption"
               v-model="formData"
               @on-load="fetchData"
               @search-change="handleSubmit">
      <template slot="searchMenu"
                slot-scope="{ size }">
        <el-button :size="size"
                   type="primary"
                   @click="handleUpdate({})">{{ $t('addOrganDrug.addDrug') }}</el-button>
      </template>
      <template slot="header">
        <el-tabs v-model="status"
                 :before-leave="changeSearch"
                 class="platform-tabs"
                 type="card">
          <el-tab-pane v-for="item in statusList"
                       :key="item.id"
                       :name="`${item.id}`"
                       :disabled="tableLoading">
            <span slot="label">
              {{ `${item.name}` }}
            </span>
          </el-tab-pane>
        </el-tabs>
      </template>
      <template slot-scope="{row}"
                slot="menu">
        <el-button type="text"
                   size="small"
                   @click="handleUpdate(row)">{{ $t('common.detail') }}</el-button>
      </template>
    </avue-crud>
    <updateOrganDrug v-if="showUpdateOrganDrug"
                     ref="updateOrganDrugRef"
                     :current-data="currentData"
                     @fetchData="fetchData" />
  </div>
</template>

<script>
import { tableOption, statusList } from '@/commonModule/assets/addOrganDrug'
import { addOrganDrugApi } from '@/commonModule/api/addOrganDrugApi'
import { defaultDate, dateFormat } from '@/util/date'
import { mapGetters } from 'vuex'
import updateOrganDrug from './updateOrganDrug'

export default {
  name: 'AddOrganDrug',
  components: { updateOrganDrug },
  data() {
    return {
      statusList: this.deepClone(statusList),
      formData: {},
      tableData: [],
      page: {
        total: 1, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 10, // 每页显示多少条
        ascs: [], // 升序字段
        descs: [], // 降序字段
        pageSizes: [10, 20]
      },
      paramsSearch: {
        dateStart: defaultDate().startData,
        dateEnd: defaultDate().endData
      },
      tableLoading: false,
      tableOption,
      showUpdateOrganDrug: false,
      status: 0,
      currentData: {}
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  methods: {
    async fetchData() {
      try {
        this.showUpdateOrganDrug = false
        if (dateFormat(+new Date(this.paramsSearch.dateStart), 'YYYY-MM') !== dateFormat(+new Date(this.paramsSearch.dateEnd), 'YYYY-MM')) {
          this.$message.warning('不支持跨月查询，请重新选择时间段')
          return
        }
        const params = {
          page: this.page.currentPage,
          pageSize: this.page.pageSize,
          organId: this.userInfo.company_code || this.userInfo.id,
          desces: 'create_time',
          status: this.status,
          ...this.paramsSearch
        }
        if (this.$route.query.source === 'store') {
          params.dispensaryUid = this.userInfo.uid
        }
        this.tableLoading = true
        const res = await addOrganDrugApi.fetchOrganDrugList(params)
        this.tableData = res.data.payload.data
        this.page.total = res.data.payload.count
        this.tableLoading = false
      } catch (e) {
        this.tableLoading = false
      }
    },
    // 改变搜索条件
    changeSearch(e) {
      this.status = e
      this.page.currentPage = 1
      this.fetchData()
    },
    handleUpdate(row) {
      this.currentData = row
      this.showUpdateOrganDrug = true
      this.$nextTick(() => {
        this.$refs.updateOrganDrugRef.isVisible = true
      })
    },
    // 查询
    handleSubmit(params, done) {
      [params.dateStart, params.dateEnd] = params.date
        ? params.date
        : []
      delete params.date
      params = this.filterForm(params)
      this.paramsSearch = params
      this.page.currentPage = 1
      this.fetchData()
      done()
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .avue-crud__menu {
  display: none;
}
/deep/ .avue-crud__header {
  display: none;
}
/deep/ .crud__menu .avue-crud__menu {
  display: block;
}
</style>
